import { setRangeMax } from './helpers';

export const setRentCommission = setRangeMax('commission');
